export default __webpack_public_path__ + "static/media/VG.1eb5fe2d.svg";